module.exports = __webpack_public_path__ + "img/img.7dd6d65e.svg";